<template>
    <div>
      <content-header title="Sub Products" :sub-title="subTitle" class="mb-0 mt--10" />
      <el-row class="mt-20" :gutter="20" v-if="isLoaded">
        <el-col
          class="mt-15"
          :span="24"
          :lg="24"
          :md="24"
          :xs="24"
          v-for="item in registration.product.subProducts"
          :key="item._id"

        >
        <div @click="toggleSelection(item)">
            <el-card
            class="item-card"
            :class="{ 'selected': isSelected(item) }"
            shadow="hover"
            >
              <div class="mt-10">
                {{item.name}}
              </div>
              <div class="mt-05 font-light description fs-08">{{ get(item, 'description') }}</div>
              <div v-if="item.selected" class="check-mark"  style="float: right; padding: 3px 0 ;color: green;" >
                <i class="el-icon-check"></i>
            </div>
            </el-card>
        </div>
        </el-col>
      </el-row>
    </div>
  </template>

<script>
import _ from 'lodash';
import {
  allSizes, countries, states, adultSizes, errormsg
} from '@/utils/constants';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };

export default {
  name: 'Store',
  props: {
    value: Object
  },
  data() {
    return {
      isLoaded: false,

      registration: {},
      allSizes,
      countries,
      get: _.get,
      states,
      selectedItems: [], // Array to store selected items
      adultSizes,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      rules: {
        address: {
          addressLine1: defaultRequiredRule,
          suburb: defaultRequiredRule,
          state: defaultRequiredRule,
          postcode: defaultRequiredRule,
          country: defaultRequiredRule,
        }
      }
    };
  },
  async mounted() {
    this.isLoaded = false;
    this.registration = this.value;

    this.isLoaded = true;
  },
  methods: {
    toggleSelection(item) {
      const index = this.selectedItems.indexOf(item);
      console.log('index', index);
      if (index === -1) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems.splice(index, 1);
      }
    },
    isSelected(item) {
      return this.selectedItems.includes(item);
    },
    updateStep(step) {
      if (step === -1) return this.$emit('update-step', this.registration, step);
      // Validate requires size
      const isValid = true;
      const hasInvalid = [];
      this.registration.subProducts = this.selectedItems;
      const hasRange = this.registration.product.hasSubProductsLimit;
      if (hasRange && this.registration.product.subProductsRange.length) {
        const range = this.registration.product.subProductsRange;
        const selected = this.selectedItems.length;
        console.log('selected', selected);
        if ((selected >= range[0] && selected <= range[1])) {
          if (isValid && !hasInvalid.length) return this.$emit('update-step', this.registration, step);
        }
        if (selected < range[0]) {
          return this.$message.error(`You have to select at least ${range[0]} item(s) `);
        }
        if (selected > range[1]) {
          return this.$message.error(`You can only select a maxium of ${range[1]} items(s)`);
        }
        return this.$message.error(`You can only select between ${range[0]} and ${range[1]} items`);
      }

      return this.$emit('update-step', this.registration, step);
    },
    checkMaxQty(rego) {
      if (
        rego.multiplePurchaseEnable
            || rego.multiplePurchaseEnable === undefined
      ) {
        return Infinity;
      }
      return 1;
    },
    fillAddress(address) {
      this.shipping.address = {
        formatted: address.formatted,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        suburb: address.suburb,
        state: address.state,
        postcode: address.postcode,
        country: address.country,
      };
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },
  },
  computed: {
    cartTotal() {
      let total = 0;
      _.forEach(this.registration.saleableItems, (i) => {
        total += i.qty * i.price;
      });
      return total;
    },
    cartQuantity() {
      return this.registration && this.registration.saleableItems ? this.registration.saleableItems.reduce((total, item) => total + item.qty, 0) : 0;
    },
    requireShipping() {
      return this.registration && this.registration.saleableItems ? this.registration.saleableItems.some((item) => item.qty > 0 && item.requireShipping) : false;
    },
    fillingAddress() {
      const rego = this.value;
      return _.get(rego, 'profile.address.formatted', false) ? rego.profile.address : false;
    },
    subTitle() {
      if (this.registration && this.registration.product) {
        const range = this.registration.product.subProductsRange;
        const hasRange = this.registration.product.hasSubProductsLimit;
        if (hasRange && range.length) {
          return `Please select the products you wish to register for. You can select between ${range[0]} and ${range[1]} items`;
        }
      }

      return 'Please select the products you wish to register for.';
    }
  },
  filters: {
    parsePrice(val) {
      return (val / 100).toFixed(2);
    }
  }
};
</script>

  <style scoped lang="scss">
  .item-card {
    border-radius: 8px;
    border-width: 0;
    background-color: rgba(#f7f8fa, .9);
  }
  .item-card.selected {
  /* Add your selected card styling here */
  border: 2px solid green; /* Example border color */
  background-color: #f0f0f0; /* Example background color */
}
.check-mark {
    // border: 2px solid #00f; /* Example border color */
    background-color: #f0f0f0; /* Example background color */
    border-radius: 50%;

}
.selected{
    /* Add your selected card styling here */
  border: 2px solid #00f; /* Example border color */
  background-color: #f0f0f0; /* Example background color */
}

  .el-input-number {
    width: 100%;
  }
  ::v-deep .item-table {
    border: 1px solid rgba(45, 58, 69, 0.1);

    &.mobile-table {
      display: none;
    }

    @media only screen and (max-width: $sm) {
      &.mobile-table {
        display: block !important;
      }
      &.desktop-table {
        display: none !important;
      }
    }

    th {
      background: #f6f8fa !important;
      padding-left: 1em;
      padding-right: 1em;
    }

    td {
      background-color: white !important;
      padding: 2em 1em;
    }
  }

  .product-container {
    .product-avatar {
      background: white !important;
      border: 1px solid rgba(45, 58, 69, 0.2);
      border-radius: 0;
      color: rgba(45, 58, 69, 0.2);
    }

    .product-info {
      .name {
        color: #2d3a45;
        font-size: 1.2em;
      }

      .description {
        font-family: $fontLight;
      }
    }
  }
  </style>
